const styles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    tableCell: {
        padding: '4px 12px 4px 0',
        '&:first-child': {
            paddingLeft: 25,
        },
        cursor: 'default'
    },
    tableCellCenter: {
        textAlign: 'center',
        padding: '4px 12px 4px 0',
    },
    buttons: {
        padding: '15px 0 0 15px'
    },
    disabledCheckboxes: {
        color: 'rgba(0, 88, 61, 0.61)'
    },
    [theme.breakpoints.up('sm')]: {
        root: {
            width: '100%',
        },
    },
    [theme.breakpoints.up('md')]: {
        root: {
            width: '94%',
        },
    },
    [theme.breakpoints.up('lg')]: {
        root: {
            width: '100%',
        },
    },
    [theme.breakpoints.up('xl')]: {
        root: {
            width: '100%',
        },
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/configuration/style/styles.js